import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';

// widgets
import ImageComp from '../widget/w-image';

const LoadingModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const loading = useSelector((state: any) => state.loading.value.loading);
  const modalRef = useRef(null);
  const modalRef1 = useRef(null);
  const [read, setRead] = useState(false);

  useEffect(() => {
    setIsVisible(loading);
    if (modalRef.current && isVisible) {
      setRead(true)
     // modalRef.current.focus();
    } else if (modalRef1.current && !isVisible) {
      //modalRef1.current.focus();
    }
  }, [loading]);

  return (
    <div className='loading-content-box' >
      {isVisible ? (
        <div
          ref={modalRef}
          tabIndex={-1}
          role='alert'
          aria-label='Loading'
          aria-modal='true'
          aria-live='polite'
          aria-describedby={'loading-description'}
          className='loading-modal'
        >
          <ImageComp
            imageClass='loader_css'
            src='/asset/Loader.gif'
            alt='Loading'
            ariaLabel='Loading'
          ></ImageComp>
          <div id='loading-description' className='content-hide text_caption_bold'>
            please wait
          </div>
        </div>
      ) : read && (
        <div
          ref={modalRef1}
          role='alert'
          aria-label='Loading'
          aria-modal='true'
          aria-live='polite'
          aria-describedby={'loading-description'}
        >
          <div id='loading-description' className='content-hide'>
            Completed
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingModal;
